<template>
    <v-stepper v-model="e1" class="elevation-0">
    <v-stepper-header class="elevation-0">
      <v-stepper-step :complete="e1 > 1" step="1">Info om dig</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">Medlemsskab</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">Betaling af kontingent</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-alert dense outlined v-if="hasError" type="error">
          {{errorMsg}}
        </v-alert>
        <v-form
          v-model="infoValid"
          ref="form1"
          v-on:submit.prevent="e1 = 2"
        >
          <v-text-field
            label="Email"
            type="email"
            v-model="email"
            :rules="emailRules"
          ></v-text-field>
          <v-text-field
            v-model="navn"
            :rules="[v => !!v || 'Navn er påkrævet']"
            label="Navn"
            required
          ></v-text-field>

          <v-text-field
            v-model="adresse"
            label="Adresse"
          ></v-text-field>

          <v-text-field
            v-model="postnummer"
            label="Postnummer"
          ></v-text-field>

          <v-text-field
            v-model="by"
            label="By"
          ></v-text-field>

          <v-text-field
            v-model="telefon"
            label="Telefon (uden +45)"
          ></v-text-field>

          <v-checkbox
            v-model="nyhedsbrev"
            label="Jeg vil gerne modtage et nyhedsbrev (hvis der en dag kommer et)"
          >
          hallo
          </v-checkbox>

          <v-btn
            color="accent"
            x-large
            white--text
            class="ma-2"
            :disabled="!infoValid"
            @click="e1 = 2"
          >
            Videre<v-icon right dark>mdi-arrow-right</v-icon>
          </v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-form
          v-model="medlemsskabValid"
          ref="form2"
          v-on:submit.prevent="gemmedlem"
        >
          <v-radio-group v-model="medlemstype" :mandatory="true">
            <v-radio label="Enkeltperson (100kr/år)" value="enkeltperson"></v-radio>
            <v-radio label="Familiemedlemsskab (250kr/år)" value="familie"></v-radio>
          </v-radio-group>

          <v-btn
            color="accent"
            x-large
            white--text
            class="ma-2"
            :disabled="!medlemsskabValid"
            type="submit"
          >
            Videre<v-icon right dark>mdi-arrow-right</v-icon>
          </v-btn>
        </v-form>

        <v-btn @click="e1 = 1" text>Tilbage</v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <p>Du betaler dit kontingent med det samme, og opretter samtidig en betalingsaftale igennem mobilepay.<br/>
        Du kan altid finde din betalingsaftale i din MobilePay app, hvor du også kan opsige din aftale (du opsiger samtidig automatisk dit medlemsskab)</p>
        <p>Hvis du vil vide mere om betalingsaftaler igennem MobilePay, kan du klikke dig ind <a target="_blank" href="https://www.mobilepay.dk/hjaelp/mobilepay-til-private/brug/betaling-med-mobilepay/regninger-og-faste-betalinger#scroll">her</a>.</p>
        <br/>
        <p>
        <a v-bind:href="betalingsURL"><img :src="require('../assets/mobilepay.png')" /></a>
        </p><br/>
        <v-btn @click="e1 = 2" text>Tilbage</v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>

import MedlemsService from '@/services/MedlemsService'

export default {
  name: 'NytMedlem',

  data: () => ({
    e1: '1',
    infoValid: false,
    medlemsskabValid: false,
    navn: '',
    medlemstype: 'enkeltperson',
    adresse: '',
    postnummer: '',
    by: '',
    password: '',
    email: '',
    telefon: '',
    nyhedsbrev: false,
    emailRules: [
      v => !!v || 'Email er påkrævet',
      v => /.+@.+\..+/.test(v) || 'Email invalid'
    ],
    medlemsnummer: '',
    betalingsBaseURL: 'https://hvorerderenvoksen-medlem.dk/api/betal?medlem=',
    betalingsURL: '',
    errorMsg: '',
    hasError: false
  }),
  methods: {
    async gemmedlem () {
      this.hasError = false
      try {
        const medlem = await MedlemsService.nytmedlem({
          email: this.email,
          navn: this.navn,
          medlemstype: this.medlemstype,
          adresse: this.adresse,
          postnummer: this.postnummer,
          by: this.by,
          nyhedsbrev: this.nyhedsbrev,
          telefon: this.telefon
        })
        this.medlemsnummer = medlem.data.user.id
        this.betalingsURL = this.betalingsBaseURL + this.medlemsnummer
        this.e1++
      } catch (error) {
        this.hasError = true
        this.errorMsg = error.response.data.error
        this.e1 = 1
      }
    }
  }
}
</script>
